import React from "react";
import { Menu, MenuItem } from "@mui/material";
import { Permissions } from "../../../../../leads/lead-view/lead-view.props";

interface AttachmentActionsMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  type: "LINK" | "FILE";
  onClose: () => void;
  onView: () => void;
  onEdit?: () => void;
  onDownload?: () => void;
  onDelete: () => void;
  permissions: Permissions;
}

const AttachmentActionsMenu: React.FC<AttachmentActionsMenuProps> = ({
  open,
  anchorEl,
  type,
  onClose,
  onView,
  onEdit,
  onDownload,
  onDelete,
  permissions,
}) => {
  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <MenuItem
        onClick={() => {
          onView();
        }}
      >
        View
      </MenuItem>

      {type === "LINK" && onEdit && permissions?.canWrite && (
        <MenuItem
          onClick={() => {
            onEdit();
          }}
        >
          Edit
        </MenuItem>
      )}

      {type === "FILE" && onDownload && (
        <MenuItem
          onClick={() => {
            onDownload();
          }}
        >
          Download
        </MenuItem>
      )}
      {permissions?.canDelete && (
        <MenuItem
          onClick={() => {
            onDelete();
          }}
        >
          Archive
        </MenuItem>
      )}
    </Menu>
  );
};

export default AttachmentActionsMenu;
